'use client';

import React, { useState } from 'react';
import { Flex, Text, Box, VStack, HStack, Separator } from '@skin-seoul/design-system';
import { LucideIcon } from '../LucideIcon';
import { TrackingTimeline } from './TrackingTimeline';
interface TrackingEvent {
  id: string;
  type: string;
  title: string;
  timestamp: string;
  status: 'completed' | 'current' | 'pending';
}
interface OrderTrackingInfoProps {
  deliveryDate: string;
  trackingNumber: string;
  trackingEvents: TrackingEvent[];
}
const copyToClipboard = (text: string) => {
  navigator.clipboard.writeText(text);
};
export const OrderTrackingInfo = ({
  deliveryDate,
  trackingNumber,
  trackingEvents
}: OrderTrackingInfoProps) => {
  const [isTimelineExpanded, setIsTimelineExpanded] = useState(true);
  const toggleTimeline = () => {
    setIsTimelineExpanded(!isTimelineExpanded);
  };
  return <VStack gap={4} bg="neutral.50" borderRadius="8px" padding={3} width="100%" data-sentry-element="VStack" data-sentry-component="OrderTrackingInfo" data-sentry-source-file="OrderTrackingInfo.tsx">
      <Flex justifyContent="space-between" alignItems="flex-start" width="100%" data-sentry-element="Flex" data-sentry-source-file="OrderTrackingInfo.tsx">
        <VStack gap={3} alignItems="flex-start" data-sentry-element="VStack" data-sentry-source-file="OrderTrackingInfo.tsx">
          <VStack gap={1.25} alignItems="flex-start" data-sentry-element="VStack" data-sentry-source-file="OrderTrackingInfo.tsx">
            <Text textStyle="label.small" fontWeight="regular" color="neutral.400" data-sentry-element="Text" data-sentry-source-file="OrderTrackingInfo.tsx">
              Delivery Date
            </Text>
            <Text textStyle="label.medium" fontWeight="medium" color="neutral.700" data-sentry-element="Text" data-sentry-source-file="OrderTrackingInfo.tsx">
              {deliveryDate}
            </Text>
          </VStack>
          <HStack gap={1} data-sentry-element="HStack" data-sentry-source-file="OrderTrackingInfo.tsx">
            <Text textStyle="label.small" fontWeight="regular" color="neutral.400" data-sentry-element="Text" data-sentry-source-file="OrderTrackingInfo.tsx">
              Tracking: {trackingNumber}
            </Text>
            <Box cursor="pointer" onClick={() => copyToClipboard(trackingNumber)} _hover={{
            opacity: 0.8
          }} width={4} height={4} color="neutral.400" data-sentry-element="Box" data-sentry-source-file="OrderTrackingInfo.tsx">
              <LucideIcon name="Copy" width={4} height={4} data-sentry-element="LucideIcon" data-sentry-source-file="OrderTrackingInfo.tsx" />
            </Box>
          </HStack>
        </VStack>
        <HStack gap={1} cursor="pointer" _hover={{
        opacity: 0.8
      }} onClick={toggleTimeline} data-sentry-element="HStack" data-sentry-source-file="OrderTrackingInfo.tsx">
          <Text textStyle="label.small" fontWeight="regular" color="neutral.400" data-sentry-element="Text" data-sentry-source-file="OrderTrackingInfo.tsx">
            Track
          </Text>
          <Box width={4} height={4} color="neutral.400" data-sentry-element="Box" data-sentry-source-file="OrderTrackingInfo.tsx">
            <LucideIcon name={isTimelineExpanded ? 'CircleMinus' : 'CirclePlus'} width={4} height={4} data-sentry-element="LucideIcon" data-sentry-source-file="OrderTrackingInfo.tsx" />
          </Box>
        </HStack>
      </Flex>

      {isTimelineExpanded && <>
          <Separator width="100%" borderColor="neutral.100" />

          <TrackingTimeline events={trackingEvents} />
        </>}
    </VStack>;
};